module.exports = __webpack_public_path__ + "img/flexsale_paper_wireframe.8032dc81.png";